import { useEffect } from "react";
import { app } from "@microsoft/teams-js";
import { useLocation } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";

const AuthPopup = () => {
  const location = useLocation();

  useEffect(() => {
    app.initialize().then(() => {
      const params = new URLSearchParams(location.search);
      const joinUrl = params.get("joinUrl");
      const encodedJoinUrl = encodeURIComponent(joinUrl || "");
      // const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID;
      const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
      const redirectUri = `${process.env.REACT_APP_TEAMS_APP_FRONTEND_URL}/authcallback`;

      const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=User.Read OnlineMeetings.Read&state=joinUrl=${encodedJoinUrl}`;
      setTimeout(() => {
        window.location.href = authUrl;
      }, 1000);
    });
  }, [location]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Redirecting to Microsoft login…
      </Typography>
    </Box>
  );
};
export default AuthPopup;
